import { MICompanyRelationship } from '@api';
import { Link, Typography } from '@mui/material';
import { PhoneTypography } from '@tsp-ui/core/components';


export default function InsurancesTableRow({ values }: { values: MICompanyRelationship }) {
    return (
        <tr>
            <Typography
                component="td"
                width="100%"
                variant="body2"
                padding="4px"
                noWrap
            >
                {values.contact}
            </Typography>

            <Typography
                component="td"
                variant="body2"
                padding="4px"
                noWrap
            >
                {values.insurerName}
            </Typography>

            <Typography
                component="td"
                variant="body2"
                padding="4px"
                noWrap
            >
                {values.policyNumber}
            </Typography>

            <Typography
                component="td"
                variant="body2"
                padding="4px"
                noWrap
            >
                <Link href={`mailto:${values.emailAddress}`}>
                    {values.emailAddress}
                </Link>
            </Typography>

            <PhoneTypography
                component="td"
                variant="body2"
                padding="4px"
                noWrap
            >
                {values.phone}
            </PhoneTypography>
        </tr>
    );
}
